<template>
  <div/>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

const store = useStore<RootState>();

defineOptions({
  name: 'dataTradeGroups',
});

// Базовый тип для сообщений с ID торговой группы
type TradeGroupWithId = {
  idTradeGroup: number;
};

// Базовый тип для общих полей торговой группы
type TradeGroupCommonFields = {
  name: string;
  telegram: string;
  timeframes: unknown;
};

// Типы для WebSocket сообщений компонента tradeGroups
type TradeGroupListMessage = WebSocketMessageWithFields<'trade-group-list', {
  tradeGroups: unknown[];
}>;
type TradeGroupCreateMessage = WebSocketMessageWithFields<'trade-group-create' | 'trade-group-create-success', TradeGroupWithId & TradeGroupCommonFields>;
type TradeGroupUpdateMessage = WebSocketMessageWithFields<'trade-group-update' | 'trade-group-update-success', TradeGroupWithId & TradeGroupCommonFields & {
  locked: boolean;
}>;
type TradeGroupDeleteMessage = WebSocketMessageWithFields<'trade-group-delete' | 'trade-group-delete-success', TradeGroupWithId>;
type TradeGroupLockMessage = WebSocketMessageWithFields<'trade-group-lock' | 'trade-group-lock-success', TradeGroupWithId>;
type TradeGroupUnlockMessage = WebSocketMessageWithFields<'trade-group-unlock' | 'trade-group-unlock-success', TradeGroupWithId>;

// Объединенный тип для всех сообщений
type TradeGroupsWebSocketMessage = 
  | TradeGroupListMessage 
  | TradeGroupCreateMessage 
  | TradeGroupUpdateMessage 
  | TradeGroupDeleteMessage 
  | TradeGroupLockMessage 
  | TradeGroupUnlockMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: TradeGroupsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'trade-group-list':
      store.dispatch('tradeGroups/wsSetTradeGroups', {
        tradeGroups: data.tradeGroups,
      });
      break;

    case 'trade-group-create':
    case 'trade-group-create-success':
      store.dispatch('tradeGroups/wsTradeGroupCreate', {
        idTradeGroup: data.idTradeGroup,
        name: data.name,
        telegram: data.telegram,
        timeframes: data.timeframes,
      });
      break;

    case 'trade-group-update':
    case 'trade-group-update-success':
      store.dispatch('tradeGroups/wsTradeGroupUpdate', {
        idTradeGroup: data.idTradeGroup,
        name: data.name,
        telegram: data.telegram,
        timeframes: data.timeframes,
        locked: data.locked,
      });
      break;

    case 'trade-group-delete':
    case 'trade-group-delete-success':
      store.dispatch('tradeGroups/wsTradeGroupDelete', {
        idTradeGroup: data.idTradeGroup,
      });
      break;

    case 'trade-group-lock':
    case 'trade-group-lock-success':
      store.dispatch('tradeGroups/wsTradeGroupLock', {
        idTradeGroup: data.idTradeGroup,
      });
      break;

    case 'trade-group-unlock':
    case 'trade-group-unlock-success':
      store.dispatch('tradeGroups/wsTradeGroupUnlock', {
        idTradeGroup: data.idTradeGroup,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
